import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from 'app/services/apiService';
import { showAlert } from 'app/utils';
import { setLoading, setLoadingFinished } from './loadingSlice';

const initialState = {
  messages: [],
  isDataFetched: false,
  isFirstRequest: true,
};

export const getAllMessages = createAsyncThunk('messages', async (_, { dispatch }) => {
  dispatch(setLoading());
  try {
    const {  data } = await apiService.getMessages();
    return data.data;
  } catch (error) {
    showAlert('error', error.message);
  } finally {
    dispatch(setLoadingFinished());
  }
});

export const getMessageBody = createAsyncThunk(
  'messages/getMessageBody',
  async (payload, { dispatch }) => {
    dispatch(setLoading());
    try {
      const {  data } = await apiService.getMessageBody(payload);
      return data.data;
    } catch (error) {
      showAlert('error', error.message);
    } finally {
      dispatch(setLoadingFinished());
    }
  }
);

export const updateMultipleMessage = createAsyncThunk(
  'messages/updateMessages',
  async (payload) => {
    // dispatch(setLoading());
    try {
      await apiService.updateMultipleMessage(payload);
    } catch (error) {
      showAlert('error', error.message);
    } finally {
      // dispatch(setLoadingFinished());
    }
  }
);

export const deleteMessage = createAsyncThunk(
  'message/deleteMessage',
  async (payload) => {
    // dispatch(setLoading());
    try {
      await apiService.deleteMessage(payload);
    } catch (error) {
      showAlert('error', error.message);
    } finally {
      // dispatch(setLoadingFinished());
    }
  }
);

export const deleteMultipleMessage = createAsyncThunk(
  'message/deleteMessages',
  async (payload, { dispatch }) => {
    dispatch(setLoading());
    try {
      await apiService.deleteMultipleMessage(payload);
    } catch (error) {
      showAlert('error', error.message);
    } finally {
      dispatch(setLoadingFinished());
    }
  }
);

export const getUnreadMessages = createAsyncThunk(
  'message/getUnreadMessages',
  async (payload, { dispatch }) => {
    dispatch(setLoading());
    try {
      await apiService.getUnreadMessages(payload);
    } catch (error) {
      showAlert('error', error.message);
    } finally {
      dispatch(setLoadingFinished());
    }
  }
);

export const notificationsSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    toggleRead(state, { payload }) {
      state.messages = payload;
    },

    setMessageBody(state, { payload }) {
      state.messageBodies = payload;
    },

    toggleReset(state) {
      state.isDataFetched = false;
    },
  },

  extraReducers(builder) {
    builder.addCase(getAllMessages.fulfilled, (state, { payload }) => {
      state.isFirstRequest = false;
      state.messages = payload;
      state.isDataFetched = true;
    });
  },
});

export const { toggleRead, toggleReset } = notificationsSlice.actions;
export default notificationsSlice.reducer;
